export const MenuNames = {
  /** 메인 화면 */
  MAIN_VIEW: "메인 화면",

  /** 장비 모니터링 */
  EQUIPMENT_MONITORING: "장비 모니터링",

  /** 장비 운용현황 */
  EQUIPMENT_ALL: "장비 운용현황",

  /** No.1 발전기 */
  GENERATOR_01: "No.1 발전기",

  /** No.2 발전기 */
  GENERATOR_02: "No.2 발전기",

  /** No.3 발전기 */
  GENERATOR_03: "No.3 발전기",

  /** No.4 발전기 */
  GENERATOR_04: "No.4 발전기",

  /** No.1 메인엔진 */
  MAINENGINE_01: "No.1 메인엔진",

  /** No.2 메인엔진 */
  MAINENGINE_02: "No.2 메인엔진",

  /** No.3 메인엔진 */
  MAINENGINE_03: "No.3 메인엔진",

  /** No.4 메인엔진 */
  MAINENGINE_04: "No.4 메인엔진",

  /** 데이터 분석 */
  DATA_ANALYSIS: "데이터 분석",

  /** 동일시간 차트 분석 */
  TREND_ANALYSIS: "동일시간 차트 분석",

  /** 센서 데이터 조회 */
  SENSOR_DATA_VIEW: "센서 데이터 조회",

  /** 데이터 통합 관리 */
  DATA_INTEGRATION_MANAGEMENT: "데이터 통합관리",

  /** 데이터 관리 */
  DATA_MANAGEMENT: "데이터 관리",

  /** 송수신 모니터링 */
  TRANSMISSION_RECEPTION_MONITORING: "송・수신 모니터링",

  /** 데이터 로그 */
  DATA_LOG: "데이터 로그",

  /** DB 관리 */
  DB_MANAGEMENT: "DB 관리",

  /** 저장소 관리 */
  STORAGE_MANAGEMENT: "저장소 관리",

  /** 정비지원 */
  MAINTENANCE_SUPPORT: "정비지원",

  /** 함정 알람 관리 */
  ALARM_MANAGEMENT: "함정 알람 관리",

  /** 상태진단 알람 */
  STATUS_DIAGNOSIS_ALARM: "상태진단 알람",

  /** ECS 알람 */
  ECS_ALARM: "ECS 알람",

  /** 보고서 관리 */
  REPORT_MANAGEMENT: "보고서 관리",

  /** 기술문서 관리 */
  TECH_DOC_MANAGEMENT: "기술문서 관리",

  /** 관리자 설정 */
  ADMIN_SETTINGS: "관리자 설정",

  /** 장비 정보관리 */
  EQUIPMENT_INFO_MANAGEMENT: "장비 정보관리",

  /** 사용자 관리 */
  USER_MANAGEMENT: "사용자 관리",

  /** 계정 관리 */
  ACCOUNT_MANAGEMENT: "계정 관리",

  /** 권한 관리 */
  AUTH_MANAGEMENT: "권한 관리",

  /** 접속로그 관리 */
  ACCESS_LOG_MANAGEMENT: "접속로그 관리",

  /** DB 백업 설정 */
  DB_BACKUP_SETTING: "DB 백업 설정",
};
